:host {
    display: block;
    width: 100%;
    overflow-y: auto;
}

/*
variables CSS configurables
--col-basis: define el tamaño mínimo de cada celda en la cuadrícula. Puede ser un valor fijo (ejemplo: 150px) o un porcentaje (ejemplo: 20%). El valor predeterminado es 150px.
--row-gap: define el espacio entre filas en la cuadrícula. Puede ser un valor fijo (ejemplo: 10px) o un porcentaje (ejemplo: 5%). El valor predeterminado es 5px.
*/
.menu-grid {
    display: grid;
    row-gap: var(--row-gap);
    grid-template-columns: repeat(auto-fit, minmax(var(--col-basis), 1fr));
    place-items: center;
    align-items: start;
}